<template>
  <!-- 资金支付过程台账 -->
  <div class="contain wageLedger" style="padding:1vh;width:100%;height:100%;">
    <!-- <div
      class="header-box"
      style="color:#4C9AFF;font-size:20px;line-height: 40px;display: flex;align-items: center;"
    >
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>项目资金结算</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </div>-->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>工程信息</el-breadcrumb-item>
            <el-breadcrumb-item>进度产值</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div
      style="height:calc(100% - 3vh);width:100%;position: relative;display:flex;justify-content: space-between;"
    >
      <!-- 侧边树 -->
      <el-aside width="16%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow-y: auto;">
          <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="id"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          >
            <span class="span-ellipsis" slot-scope="{ node, data }" style="width: 100%;text-align: left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
              <span :title="node.label" class="">{{data.name}}</span>
            </span>
          </el-tree>
        </el-card>
      </el-aside>
      <div class="box" style="overflow: auto;">
        <div
          style="padding:20px;text-align:left;background:#fff;border-bottom:10px solid #f5f5f5"
        >进度产值信息</div>
        <div class="build-bar" style="justify-content: space-between;">
          <div style="display:flex;justify-content: space-between;align-items:center;width:30%;">
            <!-- <p class="item" style="width:200px;">
              <el-select
                v-model="projectId"
                filterable
                clearable
                placeholder="请选择项目"
                @change="doFilter"
              >
                <el-option
                  v-for="item in searchPro"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </p>-->
            <!-- <p>总产值:{{totalValue_view}}万元</p> -->
            <!-- <el-button type="primary" size="mini" @click="editSalary" plain>编辑</el-button> -->
             <p style="display: flex;align-items: center;margin-right:1vw;">总产值：
               <span v-if="isTotal">{{totalValue_view}}</span>
               <el-input v-model="totalValue_view" v-else style="width:5vw;margin-right:0.5vw;"></el-input>万元
             </p>
            <el-button type="text" v-if="isTotal" @click="setMoney(1)">编辑</el-button>
            <el-button type="text" v-if="!isTotal" @click="setMoney(2)">确定</el-button>
            <el-date-picker
              v-model="year"
              @change="doFilter"
              type="year"
              value-format="yyyy"
              placeholder="选择年"
              style="margin:auto;width:130px;font-size:12px"
            ></el-date-picker>
          </div>
          <div style="display:flex;justify-content: space-between;align-items:center;width:30%">
            <!-- <el-input
              v-model="projectName"
              placeholder="请输入项目名称"
              style="margin-bottom: 10px; width: 85%;margin-top: 20px;font-size:12px;width:200px"
              clearable
              @input="watchInput"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>-->
            <el-button size="small" type="primary" @click="addFun">导出</el-button>
            <!-- <el-button size="small" type="success" icon="el-icon-plus" @click="addQin">添加</el-button> -->
          </div>

          <!-- <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :headers="uploadHead"
                    :data="uploadData"
                    :show-file-list="false" 
                    :on-success="handleAppSuccess">
                    <i class="el-icon-upload" style="color:#36C635;font-size:28px;font-weight: bold;"></i>
                    <div class="el-upload__text">上传</div>
          </el-upload>-->
        </div>
        <div class="box-content">
          <el-table :data="listData" border stripe height="100%" style="width: 100%;">
            <template slot="empty">
              <p>{{dataText}}</p>
            </template>
            <el-table-column label="序号" width="60" type="index"></el-table-column>
            <el-table-column label="月份">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <!-- <el-input size="mini" placeholder="请输入内容" v-model="master.contractNumber"></el-input> -->
                  <el-select v-model="master.month">
                    <el-option
                      v-for="item in groups3"
                      :key="item.getTime"
                      :label="item.getTime"
                      :value="item.getTime"
                    ></el-option>
                  </el-select>
                </span>
                <span v-else>{{ scope.row.month }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="项目名称" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-select v-model="master.projectId" filterable clearable placeholder="请选择项目">
                    <el-option
                      v-for="item in projects"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </span>
                <span v-else>{{scope.row.projectName}}</span>
              </template>
            </el-table-column>-->
            <!-- <el-table-column label="合同价款(万元)">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input size="mini" placeholder="请输入内容" v-model="master.contractMoney"></el-input>
                </span>
                <span v-else>{{ scope.row.contractMoney }}</span>
              </template>
            </el-table-column>-->

            <el-table-column label="本月产值(万元)">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input size="mini" placeholder="请输入内容" @input="getValue" v-model="master.monthPay"></el-input>
                </span>
                <span v-else>{{ scope.row.monthPay }}</span>
              </template>
            </el-table-column>
            <el-table-column label="累计产值(万元)">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input size="mini" placeholder="请输入内容" v-model="master.cumulativePay" disabled></el-input>
                </span>
                <span v-else>{{ scope.row.cumulativePay }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="累计完成工程量">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input size="mini" placeholder="请输入内容" v-model="master.cumulativeFinish" disabled></el-input>
                </span>
                <span v-else>{{ scope.row.cumulativeFinish }}</span>
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="本月付款金额(万元)">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input size="mini" placeholder="请输入内容" v-model="master.monthPay"></el-input>
                </span>
                <span v-else>{{ scope.row.monthPay }}</span>
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="付款比例（%）">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input size="mini" placeholder="请输入内容" v-model="master.payRate"></el-input>
                </span>
                <span v-else>{{ scope.row.payRate }}%</span>
              </template>
            </el-table-column> -->
             <el-table-column label="完成进度">
              <template slot-scope="scope">
                <span>{{ scope.row.cumulativeFinish }}%</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="备注">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input size="mini" placeholder="请输入内容" v-model="master.remark"></el-input>
                </span>
                <span v-else>{{ scope.row.remark }}</span>
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="操作">
              <template slot-scope="scope">
                <span
                  class="el-tag el-tag--info el-tag--mini"
                  style="cursor: pointer;margin-right: 10px;"
                  @click="pwdChange(scope.row,scope.$index,true)"
                >{{scope.row.isSet?'保存':"修改"}}</span>
                <span
                  @click="delChange(scope.row,scope.$index,true)"
                  v-if="!scope.row.isSet"
                  class="el-tag el-tag--danger el-tag--mini"
                  style="cursor: pointer;"
                >删除</span>
                <span
                  v-if="scope.row.isSet"
                  class="el-tag el-tag--mini"
                  style="cursor: pointer;"
                  @click="pwdChange(scope.row,scope.$index,false)"
                >取消</span>
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[3, 5, 10, 20]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
          ></el-pagination>
        </div>
        <!-- <div class="box-content-item">
                <p class="cell">施工企业意见：</p>
                <p class="cell">有权人签字：</p>
                <p class="cell">施工企业盖章</p>
            </div>
            <div class="box-content-item">
                <p class="cell">监理公司现场监理部意见：</p>
                <p class="cell">有权人签字：</p>
                <p class="cell">监理公司盖章</p>
            </div>
            <div class="box-content-item">
                <p class="cell">建设管理中心意见：</p>
                <p class="cell">有权人签字：</p>
                <p class="cell">建设管理单位盖章</p>
            </div>
            <div class="box-content-item wrap" style="padding:50px;">
                <div class="row" style="text-align: right;">
                    <el-button type="primary" @click="subWage">确认提交</el-button>
                </div>
                <div class="row" style="text-align: left;">
                    <p class="warning">主要事项：</p>
                    <p class="warning">1、导出工资申报表  Excel格式，根据表格对应出勤天数进行填报工资，出勤天数与日工资和合计工资必须计算一致</p>
                    <p class="warning">2、导入工资表前必须选择导入一致的月份，姓名，排序，出勤天数要与导出表格数据一致方可导入成功</p>
                </div>
        </div>-->
        <!-- <el-dialog title="设置总产值" :visible.sync="centerDialogVisible" width="30%" center>
          <el-form label-width="200px" label-position="right">
            <el-form-item label="总产值">
              <el-input v-model="totalValue" autocomplete="off" style="width:10vw;"></el-input>万元
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="setMoney()">确 定</el-button>
          </div>
        </el-dialog> -->
      </div>
    </div>
  </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
  data() {
    return {
      // search:{
      //     applyMonth:util.myTime.getCurMonth(),
      // },
      listData: [],
      groupId: '',
      // num:{
      //     money:0,
      //     person:0
      // },
      uploadUrl: myHttp.importExcelEPM, //上传地址
      uploadHead: {
        accessToken: this.$store.state.token,
      },
      uploadData: {
        entProjectId: '',
        attachmentTypeId: '',
        userId: util.session.get('user').id,
      },
      uploadUrl1: base.url + '/upload/uploadPhoto', //上传付款评依地址
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      dataText: '数据加载中...',
      entProjectId: '',
      attachmentTypeId: '',
      master: {
        settlementId: '',
        month: '',
        projectId: '',
        contractMoney: '', //合同价款（万元）
        cumulativePay: '', //累计付款（万元）
        receivingUnit: '', //累计付款（万元）
        monthFinish: '', //本月完成工程量(%)
        cumulativeFinish: '', // 累计完成工程量(%
        monthPay: '', //本月付款金额(万元)
        payRate: '', //付款比率
        remark: '', // 备注
        totalId:''
      },
      isAddFlag: false,
      proType: [],
      type: '',
      chooseDate: util.myTime.getCurTime(),
      projectId: '',
      projectName: '',
      name: '',
      year: '',
      isTotal:true,
      // 年加月
      groups3: [
        {
          getTime: new Date().getFullYear() + '-' + '01',
        },
        {
          getTime: new Date().getFullYear() + '-' + '02',
        },
        {
          getTime: new Date().getFullYear() + '-' + '03',
        },
        {
          getTime: new Date().getFullYear() + '-' + '04',
        },
        {
          getTime: new Date().getFullYear() + '-' + '05',
        },
        {
          getTime: new Date().getFullYear() + '-' + '06',
        },
        {
          getTime: new Date().getFullYear() + '-' + '07',
        },
        {
          getTime: new Date().getFullYear() + '-' + '08',
        },
        {
          getTime: new Date().getFullYear() + '-' + '09',
        },
        {
          getTime: new Date().getFullYear() + '-' + '10',
        },
        {
          getTime: new Date().getFullYear() + '-' + '11',
        },
        {
          getTime: new Date().getFullYear() + '-' + '12',
        },
      ],
      getTime: '', //当前
      joinType: '',
      projects: [],
      searchPro: [], //搜索的
      dataTree: [],
      defaultProps: {
        children: 'list',
        label: 'name',
      },
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      centerDialogVisible: false,
      totalValue: '', //总产值
      totalValue_view:'',
      totalId:'',
      entId:''
    }
  },
  mounted() {
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.groupId = this.$store.state.groupId
    }
    this.projectId = util.session.get('groupId')
    this.joinType = util.session.get('roleId')=='3'?'3':''
    this.uploadData.entProjectId = this.$route.params.id
    this.uploadData.attachmentTypeId = this.$route.params.type
    this.entProjectId = this.$route.params.id
    this.attachmentTypeId = this.$route.params.type
    this.getAll()
    this.getProject()
  },
  methods: {
    //获取所有项目
    getProject() {
      var that = this
      myHttp
        .getPageListPro({
          entId: this.groupId,
          joinType: this.joinType
        })
        .then(function (resp) {
          console.log(resp);
          if (resp.data.code == '200') {
          var list = resp.data.data.entOfficeProjectMenu || []
            that.dataTree = list
            for(var i=0;i<that.dataTree.length;i++){
              if (that.dataTree[i].list.length > 0 && (!that.currentNodekey || that.currentNodekey=='')) {
                that.currentNodekey = that.dataTree[i].list[0].id
                that.projectId = that.dataTree[i].list[0].id
                that.expandedkeys.push(that.dataTree[i].list[0].id)
                that.$nextTick(() => {
                  // treeBox 元素的ref   value 绑定的node-key
                  that.$refs.tree.setCurrentKey(that.currentNodekey)
                })
              }
            }
            that.getData()
            that.getMoney()
          }else{
            that.dataText = '暂无数据'
          }
        })
    },
    //点击树形结构
    handleNodeClick(data) {
      console.log(data)
      if (data.list) {
        return
      } else {
        this.projectId = data.id
        this.getData()
        this.getMoney()
      }
    },
    doFilter() {
      // this.uploadData.applyMonth = this.search.applyMonth
      this.getData()
    },
    //  handleSizeChange(val) {
    //     this.pageSize = val
    //     this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //     this.currentPage = val
    //     this.currentChangePage();
    // },
    // // 监控当前页码
    // currentChangePage(list) {
    //     this.getData();
    // },
    //点击过滤
    showProjectFun(index) {
      this.search.unit = index
      this.getData()
      // this.getAllNum()
    },
    //获取所有项目
    getAll() {
      console.log(111)
      var that = this
      myHttp
        .getProjectListByEntIdAndJoinType({
          entId: this.groupId,
          joinType: this.joinType,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            that.projects = list ;
            that.searchPro = list;
          }
        })
    },
    //获取数据
    getData() {
      var that = this
      myHttp
        .projectSettlementList({
          entId: this.groupId,
          projectId: this.projectId,
          pageSize: this.pageSize,
          pageNum: this.currentPage,
          projectName: this.projectName,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.projectSettlementList.list || []
            // var num = {money:0,person:list.length};
            for (var i = 0; i < list.length; i++) {
              // list[i].bilv = list[i].planPrepaidMoney && list[i].planPrepaidMoney != 0? ( (parseFloat(list[i].prepaidMoney) / parseFloat(list[i].planPrepaidMoney)) *100).toFixed(2)
              //     : 0
              // list[i].paymentVoucher = list[i].paymentVoucher && '' != list[i].paymentVoucher ? base.httpCtx + list[i].paymentVoucher : ''
              
              // if ('' != list[i].paymentVoucher) {
              //   list[i].paymentVouchers = []
              //   list[i].paymentVouchers.push(list[i].paymentVoucher)
              // }
              list[i].cumulativeFinish = (
                  ((parseInt(list[i].cumulativePay)) /
                    parseInt(that.totalValue_view)) *
                  100
                ).toFixed(2)
              // list[i].cumulativeFinish = 
              list[i].isSet = false
            }
            // num.money = num.money.toFixed(2);
            that.listData = list
            // that.num = num;

            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
            // that.totalItems = resp.data.data.pageInfo.total||0;
          } else {
            that.dataText = '暂无数据'
          }
        })
    },

    //导出
    // exportOut() {
    //   var token = this.$store.state.token
    //   window.open(
    //     myHttp.downloadEntProjectMoney +
    //       '?entProjectId=' +
    //       this.entProjectId +
    //       '&attachmentTypeId=' +
    //       this.attachmentTypeId +
    //       '&accessToken=' +
    //       token
    //   )
    // },
    //提交
    subWage() {
      // var that = this
      // var applyFormId = that.listData[0].applyFormId
      // myHttp.commitSalaryApply({
      //     applyMonth:this.search.applyMonth,
      //     projectId:this.groupId,
      //     applyFormId:applyFormId,
      //     userId:util.session.get('user').id
      // }).then(function(resp){
      //     if(resp.data.code=='200'){
      //         that.$router.go(-1);
      //         that.$message.success('提交成功');
      //     }else{
      //         that.$message.error(resp.data.msg);
      //     }
      // })
    },

    //添加
    // addQin() {
    //   if (this.isAddFlag) {
    //     this.$message.warning('请先保存当前台账')
    //     return
    //   } else if (this.master.settlementId != '') {
    //     this.$message.warning('请先保存当前编辑项')
    //     return
    //   }
    //   this.isAddFlag = true
    //   this.master = {
    //     settlementId: '',
    //     month: '',
    //     projectId: '',
    //     contractMoney: '', //合同价款（万元）
    //     cumulativePay: '', //累计付款（万元）
    //     receivingUnit: '', //累计付款（万元）
    //     monthFinish: '', //本月完成工程量(%)
    //     cumulativeFinish: '', // 累计完成工程量(%
    //     monthPay: '0', //本月付款金额(万元)
    //     payRate: '0', //付款比率
    //     remark: '', // 备注
    //     isSet: true,
    //     totalId:''
    //   }
     
    //   this.listData.push(this.master)
    // },

    //修改
    // pwdChange(row, index, cg) {
    //   //点击修改 判断是否已经保存所有操作
    //   var that = this
    //   //for (let i of this.master) {
    //   if (
    //     (this.master.settlementId != '' &&
    //       this.master.settlementId != row.settlementId) ||
    //     (this.isAddFlag && cg && !row.isSet)
    //   ) {
    //     this.$message.warning('请先保存当前编辑项')
    //     return false
    //   }
    //   //}
    //   //是否是取消操作
    //   if (!cg) {
    //     //if (!app.master_user.sel.id) app.master_user.data.splice(index, 1);
    //     this.getData()
    //     this.master = {
    //       settlementId: '',
    //       month: '',
    //       projectId: '',
    //       contractMoney: '', //合同价款（万元）
    //       cumulativePay: '', //累计付款（万元）
    //       receivingUnit: '', //累计付款（万元）
    //       monthFinish: '', //本月完成工程量(%)
    //       cumulativeFinish: '', // 累计完成工程量(%
    //       monthPay: '0', //本月付款金额(万元)
    //       payRate: '0', //付款比率
    //       remark: '', // 备注
    //     }
    //     this.isAddFlag = false
    //     return (row.isSet = !row.isSet)
    //   }
    //   //提交数据
    //   if (row.isSet) {
    //     //项目请求操作
    //     var that = this
    //     // if (
    //     //   this.master.prepaidMoney != '' &&
    //     //   this.master.planPrepaidMoney != ''
    //     // ) {
    //     //   this.master.bilv = (
    //     //     (parseFloat(this.master.prepaidMoney) /
    //     //       parseFloat(this.master.planPrepaidMoney)) *
    //     //     100
    //     //   ).toFixed(2)
    //     // }
    //     this.master.entId = this.groupId
    //     this.master.projectId = this.projectId
    //     this.master.totalId = this.totalId
    //     if(that.listData.length==0){
    //       that.master.cumulativePay = parseInt(this.monthPay)  
    //     }else{
    //       for(var i= 0;i<this.listData.length;i++){
    //         that.listData[i].monthPay=parseInt(that.listData[i].monthPay) 
    //         console.log(typeof( that.listData[i].monthPay) )  //number
    //       // that.master.cumulativePay=parseInt(that.master.cumulativePay)
    //         that.master.cumulativePay+=  that.listData[i].monthPay
       
    //       }
    //     }

    //     if (this.master.settlementId == '') {
    //       myHttp.addProjectSettlement(this.master).then(function (resp) {
    //         if (resp.data.code == '200') {
    //           that.isAddFlag = false
    //           that.$message.success('添加成功')
    //           that.getData()
    //         } else {
    //           that.$message.error(resp.data.msg)
    //         }
    //       })
    //     } else {
    //       myHttp.editProjectSettlement(this.master).then(function (resp) {
    //         if (resp.data.code == '200') {
    //           that.$message.success('保存成功')
    //           that.getData()
    //           that.master = {
    //             id: '',
    //             contractMoney: '', //合同价款（万元）
    //             cumulativePay: '', //累计付款（万元）
    //             receivingUnit: '', //累计付款（万元）
    //             monthFinish: '', //本月完成工程量(%)
    //             cumulativeFinish: '', //累计完成工程量(%)
    //             monthPay: '', //本月付款金额(万元)
    //             payRate: '', //付款比率
    //             remark: '', // 备注
    //           }
    //           this
    //         } else {
    //           that.$message.error(resp.data.msg)
    //         }
    //       })
    //     }
    //   } else {
    //     this.master = {
    //       settlementId: row.settlementId,
    //       month: row.month,
    //       projectId: row.projectId,
    //       contractMoney: row.contractMoney,
    //       cumulativePay: row.cumulativePay,
    //       receivingUnit: row.receivingUnit,
    //       monthFinish: row.monthFinish,
    //       cumulativeFinish: row.cumulativeFinish,
    //       monthPay: row.monthPay,
    //       payRate: row.payRate,
    //       remark: row.remark,
    //     }
    //     row.isSet = true
    //   }
    // },
    // 删除
    // delChange(row, index, cg) {
    //   var that = this
    //   //for (let i of this.master) {
    //   if (
    //     (this.master.settlementId != '' &&
    //       this.master.settlementId != row.settlementId) ||
    //     (this.isAddFlag && cg && !row.isSet)
    //   ) {
    //     this.$message.warning('请先保存当前编辑项')
    //     return false
    //   }
    //   this.$confirm('此操作将删除该调数据, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //   })
    //     .then(() => {
    //       myHttp
    //         .deleteProjectSettlement({
    //           settlementId: row.settlementId,
    //         })
    //         .then(function (resp) {
    //           if (resp.data.code == '200') {
    //             that.$message.success('删除成功')
    //             that.getData()
    //           } else {
    //             that.$message.error(resp.data.msg)
    //           }
    //         })
    //     })
    //     .catch((err) => {})
    // },
    watchInput(e) {
      this.projectName = e
      this.doFilter()
    },
    //
    changeType() {},
    addFun() {
      var token = this.$store.state.token
      var entId = this.entId
      var projectName = this.projectName
      var projectId = this.projectId
      var year = this.year
      var totalId  =this.totalId
      // console.log(projectType)
      window.open(
        myHttp.exportProjectSettlementList +
          '?entId=' +
           entId +
          '&projectName=' +
           projectName +
          '&year=' +
           year +
          '&projectId=' +
           projectId +
          '&totalId=' +
           totalId +
          '&accessToken=' +
           token
      )
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // setMoney
    setMoney(index) {
      if(index==1){
        this.isTotal=false
      }else{
       this.isTotal=true 
        var that = this
        myHttp.setUpTotal({
            entId: this.groupId,
            totalValue: this.totalValue_view,
            projectId: this.projectId,
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('设置成功')
              that.getMoney()
              that.getData()
            }else{
              that.$message.error(resp.data.msg)
            }
          })
        }
     
    },
    // 总产值回显
     getMoney(){
         var that = this
      // setUpTotal
      myHttp
        .totalInformation({
          projectId: this.projectId,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            if(resp.data.data){
               that.totalValue_view = resp.data.data.totalValue
               that.totalId = resp.data.data.totalId
               that.entId = resp.data.data.entId
               console.log(that.totalId,that.entId)
            }else{
              that.totalValue_view =''
                  that.totalId = ''
            }
           
          }
        })
     },
     getValue(e){
       if(this.listData==1){
            this.master.cumulativePay==e
       }
       console.log(this.listData)
       console.log(e)
     }
  },
}
</script>
<style scoped>
/* .contain {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 1%;
} */
.header-box {
  padding: 15px 20px;
  height: 70px;
  width: 100%;
  box-shadow: 1px 2px 3px 2px #ddd;
  background: #fff;
  box-sizing: border-box;
  position: relative;
  text-align: left;
}
.box {
  /* margin-top: 15px; */
  width: 83%;
  height: calc(100% - 2vh);
}
.box-content {
  width: 100%;
  height: calc(100% - 207px);
  background: #fff;
}
.box-content-item {
  width: 100%;
  background: #fff;
  min-height: 200px;
  margin-top: 6px;
  display: flex;
  align-content: center;
  align-items: center;
  box-sizing: border-box;
}
.box-content-item .cell {
  width: 33%;
  padding-left: 50px;
  text-align: left;
}
.box-content-item .row {
  width: 100%;
}
.box-content-item .row .warning {
  color: red;
}
.wrap {
  display: flex;
  flex-wrap: wrap;
}
.build-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 80px;
  background: #fff;
  border-bottom: 3px solid #f5f5f5;
  padding: 0 20px;
}
/* 字体颜色 */
.font-color1 {
  color: #ffbc01;
}
.font-color2 {
  color: #0085ff;
}
.upload-demo {
  margin: 0 20px;
}
</style>
<style>
.build-bar span {
  margin-left: 0;
}
.el-table td,
.el-table th {
  text-align: center;
}
.el-pagination {
  background: #fff;
  padding: 15px 0;
}
.build-bar > .el-button--success {
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
.el-image .el-icon-circle-close {
  color: #fff;
}
/* .wageLedger .el-button {
  color: #fff;
  background: #1890ff;
} */
</style>
<style>
.wageLedger .el-card__body{
  padding:1vh;
}
</style>